module.exports = __webpack_public_path__ + "img/nordstroms_logo.797f9717.svg";